<template>
    <div class="animated fade-in" v-if="customer">

        <b-alert variant="warning" show v-if="isExpired">You account has not been updated in in over 6 months. Please review your information and save.</b-alert>

        <div class="border-left pl-2 mb-4">
            <form-row label="Last Update" class="pt-2">
                <template v-slot:field>
                    <span class="d-inline-block py-1" v-if="customer.updated_at">{{ customer.updated_at | moment('MMMM D YYYY, h:mm:ss a') }}</span>
                    <span class="d-inline-block py-1" v-else-if="customer.created_at">{{ customer.created_at | moment('MMMM D YYYY, h:mm:ss a') }}</span>
                </template>
            </form-row>
            <form-row label="Name" class="py-2">
                <template v-slot:field>
<!--                    <c-input type="text" v-model="customer.name" placeholder="Name" title="Name"></c-input>-->
                    <span class="d-inline-block py-1">{{ customer.name }}</span>
                </template>
            </form-row>
            <form-row label="Website">
                <template v-slot:field><c-input type="text" v-model="form.website" placeholder="" title="Website"></c-input></template>
            </form-row>
            <form-row label="General Email">
                <template v-slot:field><c-input type="text" v-model="form.email" placeholder="" title="Email" required></c-input></template>
            </form-row>
            <form-row label="General Phone">
                <template v-slot:field><c-input type="text" v-model="form.phone" placeholder="" title="Phone" required></c-input></template>
            </form-row>
            <!-- <form-row label="Logo">
              <template v-slot:field>
                <div class="clearfix">
                  <document-preview
                    v-if="customer.logo"
                    :document="customer.logo"
                    :cache="false"
                    :width="100"
                    class="float-left mr-3"
                  ></document-preview>
                  <upload-button
                    :pre_loaded_document="customer.logo"
                    :editable="true"
                    :deletable="false"
                    @onUploaded="(document) => {customer.logo = document; form.logo_id = document.id}"
                    @onDocumentChange="(document) => {customer.logo = document; form.logo_id = document.id }"
                    class="float-left"
                  ></upload-button>
                </div>
              </template>
            </form-row> -->
        </div>

        <div class="clearfix" v-if="commit">
            <div class="d-inline-block float-right">
                <b-overlay :show="saving" spinner-small>
                    <b-button squared variant="sf" @click="save">{{save_label}}</b-button>
                </b-overlay>
            </div>
        </div>

    </div>
</template>

<script>
  import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
  import Customer from "@/models/Customer";
  import FormRow from "@/components/shared/FormRow";
  import moment from "moment";
  import UploadButton from '../documents/UploadButton.vue';
import DocumentPreview from '../documents/DocumentPreview.vue';

  export default {
    name: 'CustomerForm',
    components: {FormRow, UploadButton, DocumentPreview},
    props: {
      customer: {
        type: Customer,
        default: null
      },
      commit: {
        type: Boolean,
        default: true
      },
      save_label: {
        type: String,
        default: 'Save'
      },
    },
    mixins: [ToastNotifications],
    data() {
      return {
        saving: false,
        form: {
          website: null,
          email: null,
          phone: null,
          //logo_id: null,
        }
      }
    },
    computed: {
      isExpired() {
        if(!this.customer || !this.customer.id) {
            return false;
        } else if(this.customer.updated_at) {
            return moment(this.customer.updated_at).diff(moment(), 'months') >= 6;
        } else if(this.customer.created_at) {
            return moment(this.customer.created_at).diff(moment(), 'months') >= 6;
        }
        return true;
      }
    },
    methods: {
      getPayload() {
        return this.form;
      },
      save() {
        if(!this.commit) {
          return;
        }
        this.saving = true;
        this.$emit('onSave', this.customer);
        Customer.api().update(this.customer.id, this.getPayload()).then(() => {
          this.quickSuccessToast('You customer information has been updated', 'Thank you for keeping your account information up to date.');
          this.saving = false;
          this.$emit('onSaved', Customer.find(this.customer.id));
        }, () => {
          this.quickWarningToast('You customer information could not be updated', 'Please try again later.');
          this.saving = false;
        });
      }
    },
    watch: {
      form: {
        handler: function() {
          this.$emit('change', this.getPayload());
        },
        deep: true
      }
    },
    mounted() {
      for(let k in this.form) {
        if(this.customer) {
          this.form[k] = this.customer[k];
        }
      }
    }
  }
</script>
